import { render, staticRenderFns } from "./ApiErrors.vue?vue&type=template&id=4a671e6a"
import script from "./ApiErrors.vue?vue&type=script&lang=ts"
export * from "./ApiErrors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports